import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) { navigate("/", { replace: true }); return; }
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(data);
      } catch { /* ignore */ }
      navigate("/", { replace: true });
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50">
      <div className="flex flex-col items-center gap-3 text-slate-500">
        <div className="font-extrabold text-lg tracking-tight text-slate-900" style={{ fontFamily: "'Outfit', sans-serif" }}>
          ResiCetak<span className="text-sky-600">.work</span>
        </div>
        <div className="h-8 w-8 border-2 border-sky-600 border-t-transparent rounded-full animate-spin" />
        <p className="text-sm">Menyelesaikan login…</p>
      </div>
    </div>
  );
}
